import ImageAndTextHeroBlock from 'libs/wordpress/content/cmsBlocks/ImageAndTextHeroBlock';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'libs/styled';
import { above } from 'utils/mediaqueries';
import useClientHeight from 'hooks/useClientHeight';

const Section = styled('section', { shouldForwardProp: prop => ['clientHeight'].indexOf(prop) === -1 })`
    position: relative;
    width: 100vw;
    height: auto;
    aspect-ratio: 1;

    ${above.sm}{
        height: 33vw;
    }
`;

const ImageAndTextHeroModule = ({ ...props }) => {
    const clientHeight = useClientHeight();
        return (
            <Section clientHeight={clientHeight} >
                <ImageAndTextHeroBlock isHero useGridWrapper useMaxWidth headingSize="lg" {...props} />
            </Section>
        );
};

ImageAndTextHeroModule.propTypes = {
    isHero: PropTypes.bool,
};

export default ImageAndTextHeroModule;
